import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { styled } from "@mui/material/styles";
import styles from "../assets/jss/material-dashboard-react/components/cardFooterStyle.js";

// Styled component
const CardFooterRoot = styled("div", {
  shouldForwardProp: (prop) =>
    !["plain", "profile", "stats", "chart"].includes(prop),
})(({ plain, profile, stats, chart }) => ({
  ...styles.cardFooter,
  ...(plain && styles.cardFooterPlain),
  ...(profile && styles.cardFooterProfile),
  ...(stats && styles.cardFooterStats),
  ...(chart && styles.cardFooterChart),
}));

export default function CardFooter(props) {
  const { className, children, plain, profile, stats, chart, ...rest } = props;

  return (
    <CardFooterRoot
      className={classNames(className)}
      plain={plain ? 1 : 0}
      profile={profile ? 1 : 0}
      stats={stats ? 1 : 0}
      chart={chart ? 1 : 0}
      {...rest}
    >
      {children}
    </CardFooterRoot>
  );
}

CardFooter.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  stats: PropTypes.bool,
  chart: PropTypes.bool,
  children: PropTypes.node,
};
